import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadKangooImages";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-kangoo/")({
  head: () => routeHead("/admin/upload-kangoo/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
